module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Regular.245e98d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/life/RenaultLifeWeb-Regular.woff
// module id = 740
// module chunks = 6